"use client";
import React from "react";
import { humanReadableDate } from "@/src/utils/date";

const HumanReadableDate = ({ date }: { date: string }) => {
  return <>{humanReadableDate(date)}</>;
};

export default HumanReadableDate;
